export default __webpack_public_path__ + "static/media/ios-1.84c4588d.jpeg";